import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import createRootReducer from "../reducers/root-reducer";
import { createEpicMiddleware } from "redux-observable";
import reduxReset from "redux-reset";

export const history = createBrowserHistory();

export const epicMiddleware = createEpicMiddleware();

let rootEpicStarted = false;

/** redux-observable runs every registered epic for each action; call run() only once. */
export const runRootEpic = (rootEpic) => {
	if (rootEpicStarted) {
		return;
	}
	rootEpicStarted = true;
	epicMiddleware.run(rootEpic);
};

// Middleware to inject history into actions
const injectHistoryMiddleware = store => next => action => {
  action.history = history;
  return next(action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = createRootReducer(history);

// Create a store instance we can export
export const store = createStore(
	rootReducer,
	composeEnhancers(
		applyMiddleware(
			routerMiddleware(history),
			epicMiddleware,
			injectHistoryMiddleware // Inject history into actions
		),
		reduxReset()
	)
);

export default function configureStore(preloadedState) {
	if (preloadedState) {
		// If we have preloaded state, merge it with the existing store
		// This is a simplified approach - in a real app you might need more complex merging
		Object.keys(preloadedState).forEach(key => {
			store.dispatch({ type: 'MERGE_STATE', payload: { [key]: preloadedState[key] } });
		});
	}

	if (process.env.NODE_ENV !== "production") {
		if (module.hot) {
			module.hot.accept("../reducers/root-reducer", () => {
				store.replaceReducer(rootReducer);
			});
		}
	}

	return store;
}
